'use strict';

var _dateOptions = require('../var/_dateOptions');

function getNewDate() {
  return _dateOptions('newDateInternal')();
}

module.exports = getNewDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/date/internal/getNewDate.js
// module id = 114
// module chunks = 0